function getCookie(name) {
    var _document_cookie;
    var _document_cookie_split;
    // cookie might be undefined if there are no cookies at all
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    var cookieArr = (_document_cookie_split = (_document_cookie = document.cookie) === null || _document_cookie === void 0 ? void 0 : _document_cookie.split(";")) !== null && _document_cookie_split !== void 0 ? _document_cookie_split : [];
    for(var i = 0; i < cookieArr.length; i++){
        var _cookieArr_i, _cookiePair_;
        var cookiePair = (_cookieArr_i = cookieArr[i]) === null || _cookieArr_i === void 0 ? void 0 : _cookieArr_i.split("=");
        if (cookiePair != null && name === ((_cookiePair_ = cookiePair[0]) === null || _cookiePair_ === void 0 ? void 0 : _cookiePair_.trim())) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}
function setCookie(name, value) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, expires = _ref.expires, domain = _ref.domain;
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires != null ? "expires=".concat(expires, ";") : "").concat(domain != null ? "domain=".concat(domain, ";path=/;") : "");
}

export { getCookie, setCookie };
